"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonLoader = SkeletonLoader;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SkeletonLoader = require("./styles/SkeletonLoader");
function SkeletonLoader({
  height = '2rem',
  width = '100%',
  className = '',
  dataCy = 'skeleton-loader'
}) {
  return /*#__PURE__*/_react.default.createElement(_SkeletonLoader.StyledSkeletonWrapper, {
    width: width
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height
    },
    "data-testid": dataCy,
    "data-cy": dataCy,
    className: (0, _classnames.default)('skeleton-loader rounded', className)
  }));
}
SkeletonLoader.propTypes = {
  height: _propTypes.default.string,
  width: _propTypes.default.string,
  className: _propTypes.default.string,
  dataCy: _propTypes.default.string
};